module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NcVMLp/tc-custom/9781607059523.jpg?1737678476441",
      "alt": "This image is the cover for the book Patchwork City"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Patchwork City\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Bored with sewing the same old blocks? Get a bonanza of 75 modern quilt blocks from a bestselling modern designer! ")]), _c('br'), _c('br'), _vm._v("You’ll love these fresh angular designs inspired by city life, and the mix-and-match possibilities are endless! Elizabeth Hartman gets you started with six complete sampler quilts to sew. Each block is shown in three different fabric palettes. "), _c('br'), _c('br'), _vm._v("The book includes easy-to-follow cutting charts and instructions for every block. Some have links to full-size freezer-paper templates. Change up blocks, sizes, or fabrics to embark on a limitless exploration of modern style."), _c('br'), _c('br'), _vm._v("“The instructions are straightforward . . . an excellent choice for quilting collections.” —"), _c('i', [_vm._v("Library Journal")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Hartman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Hartman is a quilter, designer, craftsy.com instructor, and author of the best-selling quilting guides The Practical Guide to Patchwork and Modern Patchwork. Elizabeth's blog, ohfransson.com, has introduced thousands of people to modern quilting. She lives in Portland, Oregon.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0